export default async function getGame(credentials, link) {
    console.log(link);
    return fetch(link, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': 'Bearer ' + credentials?.token
        }},).then(
            (response) => response.text()
            .then((text) => {
                console.log("qqqqqqqqqq");
                let parser = new DOMParser();
                let doc = parser.parseFromString(text, "text/html");
                console.log(doc);
                return doc;
            }), )
}